/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif
* Licensed under MIT Ahmed Abosaif

* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.js";

import AllTickets from "views/AllTickets.js";
import SelfTickets from "views/SelfTickets.js";
import Reporting from "views/reportingview.js";


var dashRoutes = [
//Start Routes[0] for single Comonents NAV Links
[  {
    path: "/dashboard",
    name: "Dashboard (30 Days)",
    icon: "design_app",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/tickets/:all",
    name: "All Tickets",
    icon: "shopping_tag-content",
    component: AllTickets,
    layout: "/admin",
  },
  {
    path: "/self",
    name: "My Assigned",
    icon: "gestures_tap-01",
    component: SelfTickets,
    layout: "/admin",
  },


  
  {
    path: "/reporting",
    name: "Reporting",
    icon: "business_chart-pie-36",
   component: Reporting,
    layout: "/admin",
  },
 /* {
    path: "/extended-tables",
    name: "Appraisal",
    icon: "sport_trophy",
   // component: TableList,
    layout: "/admin",
  },*/
  /*{
    path: "/typography",
    name: "Admin Console",
    icon: "loader_gear",
   // component: Typography,
    layout: "/admin",
  },*/
],
//END Routes[0] for single Comonents NAV Links******************************************************

//Start Routes[1] for More Than 1  Comonents NAV DropDown Links (Used For Reporting NAV ITEM)

[  {
  path: "/test1",
  name: "Dashboard",
  icon: "design_app",
  component: Dashboard,
  layout: "/admin",
},
{
  path: "/test2",
  name: "Tickets",
  icon: "shopping_tag-content",
  component: AllTickets,
  layout: "/admin",
},
{
  path: "/test3",
  name: "My Assigned",
  icon: "gestures_tap-01",
  component: SelfTickets,
  layout: "/admin",
},


]




];
export default dashRoutes;
